/**
 * Left control for Directory / Document: bookmark opens “live” (view) mode;
 * pencil matches Products live bar — switch back to edit mode.
 */
const BookmarkButton = ({ onClick, variant = "bookmark" }) => {
  const isEdit = variant === "edit";
  return (
    <button
      type="button"
      className="round-btn"
      style={{ marginLeft: "35px" }}
      onClick={onClick}
      aria-label={
        !onClick
          ? "Bookmarks"
          : isEdit
            ? "Switch to edit mode"
            : "Open live mode"
      }
    >
      <svg
        width="35"
        height="35"
        viewBox="0 0 35 35"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect width="35" height="35" rx="17.5" fill="#CAE2FF" />
        {isEdit ? (
          <svg
            x="8.5"
            y="9.5"
            width="18"
            height="16"
            viewBox="0 0 18 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M9.6155 15.8077V13.1655L15.0443 7.7615C15.1686 7.64367 15.3028 7.55783 15.447 7.504C15.5912 7.45017 15.7353 7.42325 15.8795 7.42325C16.0367 7.42325 16.1888 7.45267 16.3358 7.5115C16.4827 7.5705 16.6163 7.659 16.7365 7.777L17.6615 8.7115C17.7692 8.836 17.8525 8.97067 17.9115 9.1155C17.9705 9.26033 18 9.40517 18 9.55C18 9.69483 17.9747 9.84225 17.924 9.99225C17.8733 10.1423 17.7858 10.2794 17.6615 10.4038L12.2578 15.8077H9.6155ZM0 14.6155V12.3923C0 11.9026 0.133 11.4491 0.399 11.0317C0.665 10.6144 1.0205 10.2936 1.4655 10.0693C2.45383 9.58475 3.45092 9.22133 4.45675 8.979C5.46258 8.73667 6.477 8.6155 7.5 8.6155C8.03333 8.6155 8.56317 8.64817 9.0895 8.7135C9.61567 8.77883 10.1435 8.87883 10.673 9.0135L7.423 12.254V14.6155H0ZM15.8828 10.5155L16.8078 9.55L15.8828 8.6155L14.9327 9.5655L15.8828 10.5155ZM7.5 7C6.5375 7 5.71358 6.65733 5.02825 5.972C4.34275 5.2865 4 4.4625 4 3.5C4 2.5375 4.34275 1.71358 5.02825 1.02825C5.71358 0.34275 6.5375 0 7.5 0C8.4625 0 9.28642 0.34275 9.97175 1.02825C10.6573 1.71358 11 2.5375 11 3.5C11 4.4625 10.6573 5.2865 9.97175 5.972C9.28642 6.65733 8.4625 7 7.5 7Z"
              fill="#0D6EFD"
            />
          </svg>
        ) : (
          <path
            d="M9.625 12.3026C10.6206 11.8863 12.0482 11.4374 13.4365 11.2979C14.9328 11.1472 16.2017 11.3688 16.9375 12.1439V23.1082C15.8856 22.5119 14.5525 22.4298 13.3229 22.5536C11.9954 22.6886 10.6566 23.0722 9.625 23.4659V12.3026ZM18.0625 12.1439C18.7983 11.3688 20.0673 11.1472 21.5635 11.2979C22.9518 11.4374 24.3794 11.8863 25.375 12.3026V23.4659C24.3422 23.0722 23.0046 22.6874 21.6771 22.5547C20.4464 22.4298 19.1144 22.5108 18.0625 23.1082V12.1439ZM17.5 11.1269C16.3919 10.1741 14.7854 10.0323 13.3229 10.1786C11.6196 10.3507 9.90062 10.9346 8.82963 11.4217C8.73136 11.4664 8.64802 11.5384 8.58957 11.6292C8.53113 11.7199 8.50003 11.8256 8.5 11.9336V24.3086C8.50003 24.4027 8.52367 24.4953 8.56876 24.5779C8.61385 24.6605 8.67894 24.7305 8.75809 24.7814C8.83723 24.8323 8.92789 24.8626 9.02176 24.8694C9.11562 24.8762 9.2097 24.8594 9.29537 24.8204C10.2876 24.3704 11.8863 23.8293 13.4354 23.6729C15.0205 23.5132 16.3491 23.7708 17.0612 24.6596C17.114 24.7252 17.1807 24.7783 17.2567 24.8147C17.3326 24.8511 17.4158 24.8701 17.5 24.8701C17.5842 24.8701 17.6674 24.8511 17.7433 24.8147C17.8193 24.7783 17.886 24.7252 17.9388 24.6596C18.6509 23.7708 19.9795 23.5132 21.5635 23.6729C23.1138 23.8293 24.7135 24.3704 25.7046 24.8204C25.7903 24.8594 25.8844 24.8762 25.9782 24.8694C26.0721 24.8626 26.1628 24.8323 26.2419 24.7814C26.3211 24.7305 26.3862 24.6605 26.4312 24.5779C26.4763 24.4953 26.5 24.4027 26.5 24.3086V11.9336C26.5 11.8256 26.4689 11.7199 26.4104 11.6292C26.352 11.5384 26.2686 11.4664 26.1704 11.4217C25.0994 10.9346 23.3804 10.3507 21.6771 10.1786C20.2146 10.0312 18.6081 10.1741 17.5 11.1269Z"
            fill="#0D6EFD"
          />
        )}
      </svg>
    </button>
  );
};

export default BookmarkButton;

